import PageHero from '../components/PageHero';
import SectionIntro from '../components/SectionIntro';
import InfoCard from '../components/InfoCard';
import CaseStudyCard from '../components/CaseStudyCard';
import ResourceCard from '../components/ResourceCard';
import Button from '../components/Button';
import { caseStudies, homeImages, impactBanner, impactHighlights, resources } from '../data/siteData';

export default function ImpactPage() {
  const ImpactIcon = impactBanner.icon;

  return (
    <>
      <PageHero
        eyebrow="Clinical Research Training Program"
        title="BrainTorch™ Launch"
        description="BrainTorch™ Launch is a workforce training program designed to prepare participants for entry-level roles in clinical research."
        image={homeImages.programs}
        compact
      />

      <section className="section shell">
        <SectionIntro
          eyebrow="Program Overview"
          title="A 6–7 month hybrid training program"
          text="The program combines hybrid instruction and applied learning to prepare participants for entry-level clinical research and healthcare roles."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {impactHighlights.map((item) => (
            <InfoCard key={item.title} icon={item.icon} title={item.title} text={item.text} />
          ))}
        </div>
      </section>

      <section className="section section--blue">
        <div className="shell banner-callout">
          <div>
            <p className="eyebrow eyebrow--light">What You’ll Learn</p>
            <h2>{impactBanner.title}</h2>
            <p>{impactBanner.text}</p>
          </div>
          <div className="banner-callout__icon">
            <ImpactIcon size={28} />
          </div>
        </div>
      </section>

      <section className="section shell">
        <SectionIntro
          eyebrow="Training Experience"
          title="Applied learning, capstone experience, and career outcomes"
          text="Participants complete a simulated clinical trial project and build preparation for entry-level clinical research roles."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {caseStudies.map((item) => (
            <CaseStudyCard key={item.category} item={item} />
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <SectionIntro
          eyebrow="Career Development & Partnerships"
          title="Support beyond training"
          text="BrainTorch™ Bio also supports career transitions and partner organizations building workforce pipelines."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {resources
            .filter((item) => ['Career Support', 'Partnerships', 'Why Partner With Us'].includes(item.tag))
            .map((item) => (
            <ResourceCard key={item.title} item={item} />
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <div className="cta-band">
          <div>
            <h2>Ready to learn more about BrainTorch™ Launch?</h2>
            <p>Join the interest list and receive updates about program timing, opportunities, and next steps.</p>
          </div>
          <Button to="/contact#contact-form" variant="teal">Join Interest List</Button>
        </div>
      </section>
    </>
  );
}
